module.exports = __webpack_public_path__ + "static/media/blb_blog_img.c3dd71a2.webp";